import React, { useState, useTransition } from "react";
import resumepdf from "../assets/SubhadipDas_Resume.pdf";

const PopUp = () => {
  // eslint-disable-next-line
  const [isPending, startTransition] = useTransition();

  const [isVisible, setIsVisible] = useState(true);
    const timer = setTimeout(() => {
      startTransition(() => {
        setIsVisible(false);
      });

      return () => clearTimeout(timer);
    }, [3000]);
  return (
    <div>
      {isVisible ? (
        <div className="bg-purple-100 dark:bg-slate-900 dark:text-white p-5 m-5 sm:flex sm:justify-center sm:flex-row-reverse rounded-3xl">
          <div>
            <div className="text-center font-semibold text-lg sm:flex gap-3">
              <div className="break-keep">{"<"}You can{" "} </div>
              <a href={resumepdf} download={"SubhadipDas_Resume"}>
                <button className="sm:w-full my-2 sm:my-0 justify-center text-center bg-purple-800 hover:bg-purple-700 duration-200 text-slate-100 px-2 py-1 rounded-lg font-bold text-sm">
                  Download
                </button>
              </a>
              <div>{" "} the latest Resume{" />"}</div>
            </div>
            {/* <div className="sm:grid grid-cols-1 sm:space-x-5 text-center mt-5 sm:mt-10"></div> */}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PopUp;
